module.exports = __webpack_public_path__ + "img/newsletter.b5bea780.jpg";